import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { Box as Container } from '@primer/react';
import { PropTableValues } from '../../src/components';
import { Label } from '@primer/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {ComparisonTable} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ComparisonTable>
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Use case</ComparisonTable.Cell>
    <ComparisonTable.Cell>GitHub</ComparisonTable.Cell>
    <ComparisonTable.Cell>Jenkins</ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Automation & CI/CD</ComparisonTable.Cell>
    <ComparisonTable.Cell>
      <Text as="p" size="300">
        Comparable native core capabilities
      </Text>
      <Text as="p" size="300">
        <a href="#">Over 13,000 GitHub Actions are available</a> in the GitHub
        Marketplace to automate your development workflow.
      </Text>
    </ComparisonTable.Cell>
    <ComparisonTable.Cell>
      <Text as="p" size="300">
        Comparable native capabilities
      </Text>
      <Text as="p" size="300">
        1,800+ community contributed Jenkins plugins{' '}
        <a href="#">in Jenkins Plugin Marketplace.</a>
      </Text>
    </ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Deployment models</ComparisonTable.Cell>
    <ComparisonTable.Cell>Cloud or self-hosted</ComparisonTable.Cell>
    <ComparisonTable.Cell>
      <Text as="p" size="300">
        Self-hosted only
      </Text>
      <Text as="p" size="300">
        CloudBees is the cloud alternative
      </Text>
    </ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Footnote>
    *** This is a biased overview of capabilities by use case, based on publicly
    available information as of 2022-05-16.
  </ComparisonTable.Footnote>
</ComparisonTable>
`}</code></pre>
    <h3>{`Optional heading`}</h3>
    <p>{`A heading can be provided using the `}<inlineCode parentName="p">{`heading`}</inlineCode>{` prop on the root `}<inlineCode parentName="p">{`<ComparisonTable>`}</inlineCode>{`. This will render a heading at an appropriate size relative to the table, and present it accordingly.`}</p>
    <p>{`For granular control over heading markup or appearance, we recommend using `}<a parentName="p" {...{
        "href": "./Heading"
      }}><inlineCode parentName="a">{`Heading`}</inlineCode></a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ComparisonTable heading="GitHub vs Jenkins">
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Use case</ComparisonTable.Cell>
    <ComparisonTable.Cell>GitHub</ComparisonTable.Cell>
    <ComparisonTable.Cell>Jenkins</ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Automation & CI/CD</ComparisonTable.Cell>
    <ComparisonTable.Cell>
      <Text as="p" size="300">
        Comparable native core capabilities
      </Text>
      <Text as="p" size="300">
        <a href="#">Over 13,000 GitHub Actions are available</a> in the GitHub
        Marketplace to automate your development workflow.
      </Text>
    </ComparisonTable.Cell>
    <ComparisonTable.Cell>
      <Text as="p" size="300">
        Comparable native capabilities
      </Text>
      <Text as="p" size="300">
        1,800+ community contributed Jenkins plugins{' '}
        <a href="#">in Jenkins Plugin Marketplace.</a>
      </Text>
    </ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Deployment models</ComparisonTable.Cell>
    <ComparisonTable.Cell>Cloud or self-hosted</ComparisonTable.Cell>
    <ComparisonTable.Cell>
      <Text as="p" size="300">
        Self-hosted only
      </Text>
      <Text as="p" size="300">
        CloudBees is the cloud alternative
      </Text>
    </ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Footnote>
    *** This is a biased overview of capabilities by use case, based on publicly
    available information as of 2022-05-16.
  </ComparisonTable.Footnote>
</ComparisonTable>
`}</code></pre>
    <h3>{`Featured columns`}</h3>
    <p>{`By default, the first data column will be marked as `}<inlineCode parentName="p">{`featured`}</inlineCode>{`. This is to draw attention to a particular product as the basis of a comparison against adjacent columns.`}</p>
    <p>{`Use `}<inlineCode parentName="p">{`featuredColumn`}</inlineCode>{` to alternate the highlighted column if needed.`}</p>
    <h4>{`Color customization`}</h4>
    <p>{`The default colors can be customized through dedicated CSS variables.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`--brand-ComparisonTable-featured-color-start`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`--base-color-scale-pink-4`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`--brand-ComparisonTable-featured-color-end`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`--base-color-scale-indigo-5`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const App = () => {
  const designTokenOverrides = \`
  .custom-colors[data-color-mode='dark'] {

    /*
     * Modify the value of these tokens.
     * Remember to apply light mode equivalents if you're enabling theme switching.
     */
    --brand-ComparisonTable-featured-color-start: var(--base-color-scale-green-2);
    --brand-ComparisonTable-featured-color-end: var(--base-color-scale-blue-3);

    /*
     * For example only
     */
    padding: 3rem;
    background-color: var(--brand-color-canvas-default);
  }

  .custom-heading {
    background: linear-gradient(271.72deg, var(--brand-ComparisonTable-featured-color-end) 7.09%, var(--brand-ComparisonTable-featured-color-start) 96.61%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    margin-bottom: var(--base-size-32);
  }
\`

  return (
    <ThemeProvider colorMode="dark" className="custom-colors">
      <style>{designTokenOverrides}</style>
      <Heading as="h3" className="custom-heading">
        GitHub vs Jenkins
      </Heading>
      <ComparisonTable>
        <ComparisonTable.Row>
          <ComparisonTable.Cell>Use case</ComparisonTable.Cell>
          <ComparisonTable.Cell>GitHub</ComparisonTable.Cell>
          <ComparisonTable.Cell>Jenkins</ComparisonTable.Cell>
        </ComparisonTable.Row>
        <ComparisonTable.Row>
          <ComparisonTable.Cell>Automation & CI/CD</ComparisonTable.Cell>
          <ComparisonTable.Cell>
            <Text as="p" size="300">
              Comparable native core capabilities
            </Text>
            <Text as="p" size="300">
              Over 13,000 GitHub Actions are available in the GitHub Marketplace
              to automate your development workflow.
            </Text>
          </ComparisonTable.Cell>
          <ComparisonTable.Cell>
            <Text as="p" size="300">
              Comparable native capabilities
            </Text>
            <Text as="p" size="300">
              1,800+ community contributed Jenkins plugins in Jenkins Plugin
              Marketplace.
            </Text>
          </ComparisonTable.Cell>
        </ComparisonTable.Row>
        <ComparisonTable.Row>
          <ComparisonTable.Cell>Deployment models</ComparisonTable.Cell>
          <ComparisonTable.Cell>Cloud or self-hosted</ComparisonTable.Cell>
          <ComparisonTable.Cell>
            <Text as="p" size="300">
              Self-hosted only
            </Text>
            <Text as="p" size="300">
              CloudBees is the cloud alternative
            </Text>
          </ComparisonTable.Cell>
        </ComparisonTable.Row>
        <ComparisonTable.Footnote>
          *** This is a biased overview of capabilities by use case, based on
          publicly available information as of 2022-05-16.
        </ComparisonTable.Footnote>
      </ComparisonTable>
    </ThemeProvider>
  )
}

render(<App />)
`}</code></pre>
    <h3>{`Dynamic data`}</h3>
    <p>{`Comparison tables are typically generated using data from an API or content management system.`}</p>
    <p><inlineCode parentName="p">{`ComparisonTable`}</inlineCode>{` accepts `}<inlineCode parentName="p">{`ReactNode`}</inlineCode>{` as a valid child, to facilitate conditional and dynamic rendering.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const App = () => {
  const comparisonTableData = {
    heading: 'GitHub vs Jenkins',
    footnotes:
      '*** This is a biased overview of capabilities by use case, based on publicly available information as of 2022-05-16.',
    headingLabels: ['', 'GitHub', 'Jenkins'],
    features: [
      {
        label: 'Automation & CI/CD',
        values: [
          {
            name: 'GitHub',
            value:
              'Over 13,000 GitHub Actions are available in the GitHub Marketplace to automate your development workflow.',
          },
          {
            name: 'Jenkins',
            value:
              '1,800+ community contributed Jenkins plugins in Jenkins Plugin Marketplace.',
          },
        ],
      },
      {
        label: 'Deployment models',
        values: [
          {
            name: 'GitHub',
            value: 'Cloud or self-hosted',
          },
          {
            name: 'Jenkins',
            value: 'Self-hosted only. CloudBees is the cloud alternative',
          },
        ],
      },
    ],
  }

  return (
    <ComparisonTable heading={comparisonTableData.heading}>
      <ComparisonTable.Row>
        {comparisonTableData.headingLabels.map((label) => (
          <ComparisonTable.Cell key={label}>{label}</ComparisonTable.Cell>
        ))}
      </ComparisonTable.Row>
      {comparisonTableData.features.map(({label, values}) => {
        return (
          <ComparisonTable.Row key={label}>
            <ComparisonTable.Cell key={label}>{label}</ComparisonTable.Cell>
            {values.map(({value, name}) => (
              <ComparisonTable.Cell key={name}>{value}</ComparisonTable.Cell>
            ))}
          </ComparisonTable.Row>
        )
      })}
      <ComparisonTable.Footnote>
        {comparisonTableData.footnotes}
      </ComparisonTable.Footnote>
    </ComparisonTable>
  )
}

render(<App />)
`}</code></pre>
    <h3>{`Minimal layout`}</h3>
    <p><inlineCode parentName="p">{`ComparisonTable`}</inlineCode>{` has an alternative visual presentation mode called `}<inlineCode parentName="p">{`minimal`}</inlineCode>{`. This will display the data without the featured columns.`}</p>
    <p>{`This variant is suitable for embedding into long-form content, or in situations where usage of on-screen color needs to be minimized.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ComparisonTable heading="What is containerization?" variant="minimal">
  <ComparisonTable.Row>
    <ComparisonTable.Cell></ComparisonTable.Cell>
    <ComparisonTable.Cell>Containerization</ComparisonTable.Cell>
    <ComparisonTable.Cell>Virtualization</ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Operating system (OS) </ComparisonTable.Cell>
    <ComparisonTable.Cell>
      Containers use the host OS, meaning all containers must be compatible with
      that OS.
    </ComparisonTable.Cell>
    <ComparisonTable.Cell>
      VMs are effectively separate computers that run their own OS. For example,
      a VM can run Windows even if the host OS is Ubuntu.
    </ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Computing resources </ComparisonTable.Cell>
    <ComparisonTable.Cell>
      Containers are lightweight, taking only the resources needed to run the
      application and the container manager.{' '}
    </ComparisonTable.Cell>
    <ComparisonTable.Cell>
      VMs emulate a full computer, meaning that they replicate much of the host
      environment. That uses more memory, CPU cycles, and disk space.
    </ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Shareability </ComparisonTable.Cell>
    <ComparisonTable.Cell>
      Container images are relatively small in size, making them easy to share.
    </ComparisonTable.Cell>
    <ComparisonTable.Cell>
      VM images are often much larger as they include a full OS.
    </ComparisonTable.Cell>
  </ComparisonTable.Row>
  <ComparisonTable.Row>
    <ComparisonTable.Cell>Security</ComparisonTable.Cell>
    <ComparisonTable.Cell>
      Containers might be isolated only very lightly from each other. A process
      in one container could access memory used by another container, for
      example.
    </ComparisonTable.Cell>
    <ComparisonTable.Cell>
      By running a separate OS, VMs running on the same hardware are more
      isolated from one another than containers.
    </ComparisonTable.Cell>
  </ComparisonTable.Row>
</ComparisonTable>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`ComparisonTable `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ComparisonTable.Row`}</inlineCode>{`, `}<inlineCode parentName="td">{`ComparisonTable.Cell`}</inlineCode>{`, `}<inlineCode parentName="td">{`ComparisonTable.Footnotes`}</inlineCode>{`, `}<inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`undefined`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Valid children. Accepts `}<inlineCode parentName="td">{`ReactNode`}</inlineCode>{` for conditional rendering.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`heading`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`undefined`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional heading that appears above table, preconfigured as a `}<inlineCode parentName="td">{`h3`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`featuredColumn`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates that the data column at the specified index is visually important and unique in relation to its adjacent cells, and will be styled accordingly.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`variant`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`"default"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"minimal"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`"default"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Applies alternative presentation.`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`ComparisonTable.Row `}<Label mdxType="Label">{`Required`}</Label></h3>
    <p>{`The first row in a table is automatically styled as a table header row.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ComparisonTable.Cell`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`undefined`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cells (columns) to be displayed inside the row.`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`ComparisonTable.Cell `}<Label mdxType="Label">{`Required`}</Label></h3>
    <p>{`The first cell in a row is automatically styled as a header cell.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`undefined`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content to be displayed inside the column cell.`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`ComparisonTable.Footnote`}</h3>
    <p>{`Optional node that appears below the table. This is useful for adding additional context or disclaimers.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`undefined`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content to be displayed inside the column cell.`}</td>
        </tr>
      </tbody>
    </table>
    <p><inlineCode parentName="p">{`id`}</inlineCode>{`, `}<inlineCode parentName="p">{`className`}</inlineCode>{` and `}<inlineCode parentName="p">{`ref`}</inlineCode>{` are forwarded by default to all children.`}</p>
    <h2>{`Design tokens`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`css`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`js`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--brand-ComparisonTable-featured-color-start`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`brand.ComparisonTable.featured.color.start`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`--brand-ComparisonTable-featured-color-end`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`brand.ComparisonTable.featured.color.end`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      